var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper layout-wrapper"},[(this.$store.state.popupPayload.isModalOpen)?_c('popupMessage',{attrs:{"msg":this.$store.state.popupPayload.popupMsg}}):_vm._e(),_c('Navigation'),_c('div',{staticClass:"layout"},[_c('router-view')],1),_c('footer-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }